import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	workflows: {
		id: 'spa-apps-sidebar-servicedesk.common.settings-classic.requests-management.workflows',
		defaultMessage: 'Workflows',
		description: 'Settings navigation menu link for a service project',
	},
	screens: {
		id: 'spa-apps-sidebar-servicedesk.common.settings-classic.requests-management.screens',
		defaultMessage: 'Screens',
		description: 'Settings navigation menu link for a service project',
	},
	fields: {
		id: 'spa-apps-sidebar-servicedesk.common.settings-classic.requests-management.fields',
		defaultMessage: 'Fields',
		description: 'Settings navigation menu link for a service project',
	},
	issueTypes: {
		id: 'spa-apps-sidebar-servicedesk.common.settings-classic.requests-management.issue-types',
		defaultMessage: 'Issue types',
		description: 'Settings navigation menu link for a service project',
	},
	issueLayout: {
		id: 'spa-apps-sidebar-servicedesk.common.settings-classic.requests-management.issue-layout',
		defaultMessage: 'Issue layout',
		description: 'Settings navigation menu link for a service project',
	},
	requestTypes: {
		id: 'spa-apps-sidebar-servicedesk.common.settings-classic.requests-management.request-types',
		defaultMessage: 'Request types',
		description: 'Settings navigation menu link for a service project',
	},
	forms: {
		id: 'spa-apps-sidebar-servicedesk.common.settings-classic.requests-management.forms',
		defaultMessage: 'Forms',
		description: 'Nav item label for configuring forms of a servicedesk project',
	},
	sla: {
		id: 'spa-apps-sidebar-servicedesk.common.settings-classic.requests-management.sla',
		defaultMessage: 'SLAs',
		description: 'Settings navigation menu link for a service project',
	},
	customerSatisfaction: {
		id: 'spa-apps-sidebar-servicedesk.common.settings-classic.requests-management.customer-satisfaction',
		defaultMessage: 'Customer satisfaction',
		description: 'Settings navigation menu link for a service project',
	},
});
